<template>
    <component :is="loadComponent(type)" :type="type" :id="id" />
</template>

<script>

import Default from './Default.vue';
import DefaultGraphQL from './DefaultGraphQL.vue';
import Unleashed from './Unleashed.vue';

export default {
    components: { Default, DefaultGraphQL, Unleashed },
    props: {
        id: { type: Number, default: null },
        type: { type: String, default: "" },
    },

    methods: {
        loadComponent(platform) {

            // Define a mapping of integration types
            const componentMap = {
                'Shopify': DefaultGraphQL,
                'Shopify Update Only': DefaultGraphQL,
                'Unleashed': Unleashed,
            };

            // Check if the integration type exists in the map
            if (componentMap[platform]) {
                return componentMap[platform];
            }

            // Fallback to a default component if no match is found
            return Default;
        }
    }
}
</script>